var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6 2.13333H28.8C30.5673 2.13333 32 3.56602 32 5.33333V27.2149C32 28.9822 30.5673 30.4149 28.8 30.4149H3.2C1.43269 30.4149 0 28.9822 0 27.2149V5.33333C0 3.56602 1.43269 2.13333 3.2 2.13333H6.4V0H8.53333V2.13333H23.4667V0H25.6V2.13333ZM6.4 4.26667H3.2C2.6109 4.26667 2.13333 4.74423 2.13333 5.33333V9.0816H29.8667V5.33333C29.8667 4.74423 29.3891 4.26667 28.8 4.26667H25.6V6.4H23.4667V4.26667H8.53333V6.4H6.4V4.26667ZM3.2 28.2816C2.6109 28.2816 2.13333 27.804 2.13333 27.2149V11.2149H29.8667V27.2149C29.8667 27.804 29.3891 28.2816 28.8 28.2816H3.2ZM10.0416 15.4667L8.53333 13.9584L7.02507 15.4667L8.53333 16.9749L10.0416 15.4667ZM8.53333 18.24L10.0416 19.7483L8.53333 21.2565L7.02507 19.7483L8.53333 18.24ZM10.0416 24.0299L8.53333 22.5216L7.02507 24.0299L8.53333 25.5381L10.0416 24.0299ZM16 13.9584L17.5083 15.4667L16 16.9749L14.4917 15.4667L16 13.9584ZM17.5083 19.7483L16 18.24L14.4917 19.7483L16 21.2565L17.5083 19.7483ZM16 22.5216L17.5083 24.0299L16 25.5381L14.4917 24.0299L16 22.5216ZM24.9749 15.4667L23.4667 13.9584L21.9584 15.4667L23.4667 16.9749L24.9749 15.4667ZM23.4667 18.24L24.9749 19.7483L23.4667 21.2565L21.9584 19.7483L23.4667 18.24ZM24.9749 24.0299L23.4667 22.5216L21.9584 24.0299L23.4667 25.5381L24.9749 24.0299Z",
    fill: "#10710E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.59d06aa132e08c4b4275c9ece4d10c27.svg";
export { ForwardRef as ReactComponent };